import React from 'react';
function TabNew({ index, activeIndex, text, onClick }) {
    const isActive = index === activeIndex;
    return (
        <div className={isActive ? 'tab-active' : 'tab-inactive'} onClick={() => onClick(index)}>
            <p className={isActive ? 'tab-text-active two-line-text' : 'tab-text-inactive two-line-text'}>{text}</p>
        </div>
    );
}

export default function TabNews({ activeIndex, onTabChange, tabsToShow = [] }) {
    return (
        <section className="d-flex flex-row align-items-center justify-content-center mt-0">
            <div className="tabs-parent">
                {tabsToShow.map((tab, idx) => (
                    <React.Fragment key={idx}>
                        <TabNew index={tab.index} activeIndex={activeIndex} text={tab.label} onClick={onTabChange} />
                        {idx !== tabsToShow.length - 1 && <div className="ms-2 me-2"></div>} {/* Space between tabs */}
                    </React.Fragment>
                ))}
            </div>
        </section>
    );
}